import React from "react";
import { usePageMetadata } from "./hooks/usePageMetadata";
import { ReadingProgress } from "./components/ReadingProgress";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/Hero";
import { ValueStrip } from "./components/ValueStrip";
import { Problems } from "./components/Problems";
import { Bridge } from "./components/Bridge";
import { ProductShowcase } from "./components/ProductShowcase";
import { Tomos } from "./components/Tomos";
import { PreviewGallery } from "./components/PreviewGallery";
import { Bonuses } from "./components/Bonuses";
import { OfferTransition } from "./components/OfferTransition";
import { Offer } from "./components/Offer";
import { Guarantee } from "./components/Guarantee";
import { FAQ } from "./components/FAQ";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";
export function App() {
  usePageMetadata("Pequeños Pasos, Grandes Logros | Estrategias prácticas para acompañar", "Colección digital de 6 guías con estrategias concretas para rutinas, atención, regulación emocional, comunicación y acompañamiento cotidiano en casa.");
  return <div className="w-full overflow-x-hidden bg-white text-[var(--ink)]" data-id="element-0" data-mp="3rc9co3oln7vn">
      <MetaPixel data-id="element-1" data-mp="3recedkz46pg7" />
      <ReadingProgress data-id="element-2" data-mp="5yj0slx59ec" />

      <main className="w-full" data-id="element-3" data-mp="67z9oh5w26u">
        <Hero data-id="element-4" data-mp="5ggje8nxyxz" />
        <ValueStrip data-id="element-5" data-mp="82ld64660ci" />
        <Problems data-id="element-6" data-mp="2zl3bdjx5744s" />
        <Bridge data-id="element-7" data-mp="2zllduyaeeel5" />
        <ProductShowcase data-id="element-8" data-mp="2zm4wkh7vh708" />
        <Tomos data-id="element-9" data-mp="2zmwj72jhrued" />
        <PreviewGallery data-id="element-10" data-mp="2zng1ikd20ksx" />
        <Bonuses data-id="element-11" data-mp="33mf0zpg0npcz" />
        <OfferTransition data-id="element-12" data-mp="33lx0ggmbmoz9" />
        <Offer data-id="element-13" data-mp="33n6xr3lcnt4u" />
        <Guarantee data-id="element-14" data-mp="33orik1hv3xpi" />
        <FAQ data-id="element-15" data-mp="38lrqkhy9vaj9" />
        <FinalCTA data-id="element-16" data-mp="38l8idsyfc0if" />
      </main>

      <Footer data-id="element-17" data-mp="38l05i12awv78" />
    </div>;
}